import Space from "Components/Space";
import PageLayout from "Layouts/PageLayout";
import {useNavigate, useParams} from "react-router-dom";
import CalculatorIcon from "../../../Assets/SVG/CalculatorIcon";
import ProjectSettlementSettingsForm from "../../../Features/Settlements/ProjectSettlementSettingsForm";
import {useSettlementSetting} from "../../../Apis/ProjectSettlementSettingsApi";
import {useTranslation} from "react-i18next";

const Edit = () => {

    const { id } = useParams();
    
    const { t } = useTranslation();

    const { data: settlementProduct, isLoading } = useSettlementSetting(parseInt(id!));

    const navigate = useNavigate();

    return (
        <PageLayout title={t('settings')} icon={<CalculatorIcon />} includeBox loading={isLoading}>
            <Space size={"large"} direction={"vertical"}>
                <ProjectSettlementSettingsForm settlementSettings={settlementProduct!} onSubmit={_ => navigate(-1)} />
            </Space>
        </PageLayout>
    )

}

export default Edit;